/**
 * Initialize WooCommerce event listeners.
 *
 * @since 1.0.0
 */

import { handleWooCommerceAddedToCartEvent } from '../handle-woocommerce-added-to-cart-event';

/**
 * Initialize WooCommerce event listeners.
 *
 * @since 1.0.0
 *
 * @return void
 */
export const initWooCommerceEventListeners = (): void => {
  // Set up jQuery event listener for WooCommerce added_to_cart event.
  // This is the primary method for capturing add to cart events.
  if (typeof window.jQuery !== 'undefined') {
    window.jQuery(document.body).on('added_to_cart', (_event, fragments, cartHash) => {
      handleWooCommerceAddedToCartEvent(fragments as Record<string, string>, cartHash as string);
    });
  }
};
